import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--down",
  "use": "icon-arrow--down-usage",
  "viewBox": "0 0 8 4",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 4\" id=\"icon-arrow--down\"><path d=\"M1.057.553A.182.182 0 0 0 1 .682a.172.172 0 0 0 .057.129l2.806 2.636A.195.195 0 0 0 4 3.5a.204.204 0 0 0 .137-.053L6.943.81A.182.182 0 0 0 7 .68a.172.172 0 0 0-.057-.128A.195.195 0 0 0 6.806.5a.204.204 0 0 0-.137.053L4 3.06 1.33.553A.2.2 0 0 0 1.194.5a.2.2 0 0 0-.136.053Z\" fill=\"currentColor\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol